const RequiredIcon = () => <span className="text-danger">*</span>

export default RequiredIcon
